// extracted by mini-css-extract-plugin
module.exports = {"content":"meteoinfo_content__r7D05","center":"meteoinfo_center__2ZnqT"};